import { render, staticRenderFns } from "./popup-card.vue?vue&type=template&id=5ad43c3d&scoped=true&"
import script from "./popup-card.ts?vue&type=script&lang=ts&"
export * from "./popup-card.ts?vue&type=script&lang=ts&"
import style0 from "./popup-card.scss?vue&type=style&index=0&id=5ad43c3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad43c3d",
  null
  
)

export default component.exports